/*
 * @Author: syc
 * @Date: 2023-04-01 23:24:52
 * @LastEditors: syc
 * @LastEditTime: 2023-05-11 15:28:15
 * @FilePath: \drug-testing\src\main.ts
 * @Description: main.js
 * Copyright (c) 2023 by song, All Rights Reserved.
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  Button,
  Image as VanImage,
  Loading,
  Row,
  Col,
  Icon,
  Swipe,
  SwipeItem,
  Collapse,
  CollapseItem,
  Form,
  Field,
  Checkbox,
  CheckboxGroup,
  Toast,
  Dialog,
  ActionSheet,
  Popup,
  Picker,
  Tab,
  Tabs,
  Grid,
  GridItem
} from 'vant'

// 加载全局样式
import './styles/index.scss'

import './utils/rem.js'

import * as moment from 'moment'

Vue.prototype.$moment = moment

Vue.config.productionTip = false

Vue.use(Button)
  .use(VanImage)
  .use(Loading)
  .use(Row)
  .use(Col)
  .use(Icon)
  .use(Swipe)
  .use(SwipeItem)
  .use(Collapse)
  .use(CollapseItem)
  .use(Form)
  .use(Field)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Toast)
  .use(Dialog)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(Tab)
  .use(Tabs)
  .use(Grid)
  .use(GridItem)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
